import ChatButton from '../packages/button/index.js'
import ChatImg from '../packages/img/index.js'
import ChatImgLazy from '../packages/img/lazy.js'
import ChatTooltip from '../packages/tooltip/index.js'
import ChatSearchInput from '../packages/search-input/index.js'
import ChatRoomAvatar from '../packages/room-avatar/index.js'
import ChatHoverCard from '../packages/hover-card/index.js'
import ChatDialog from '../packages/dialog/index.js'
import ChatFullDialog from '../packages/full-dialog/index.js'
import ChatMoreLoading from '../packages/more-loading/index.js'
import ChatSearchSelector from '../packages/search-selector/index.js'
import ChatCheckBox from '../packages/check-box/index.js'
import ChatCircleLoading from '../packages/circle-loading/index.js'
import ChatOpenLink from '../packages/open-link/index.js'
import ChatSwitchButton from '../packages/switch-button/index.js'
import ChatSlider from '../packages/slider/index.js'
import ChatTextarea from '../packages/textarea/index.js'

const components = [
  ChatButton,
  ChatImg,
  ChatImgLazy,
  ChatTooltip,
  ChatSearchInput,
  ChatRoomAvatar,
  ChatHoverCard,
  ChatDialog,
  ChatFullDialog,
  ChatMoreLoading,
  ChatSearchSelector,
  ChatCheckBox,
  ChatCircleLoading,
  ChatOpenLink,
  ChatSwitchButton,
  ChatSlider,
  ChatTextarea,
]

const install = function(Vue) {
  components.forEach((component) => {
    component.install(Vue)
  })
}

export default { 
  install,
  ChatButton,
  ChatImg,
  ChatTooltip,
  ChatSearchInput,
  ChatRoomAvatar,
  ChatHoverCard,
  ChatDialog,
  ChatFullDialog,
  ChatMoreLoading,
  ChatSearchSelector,
  ChatCircleLoading,
  ChatSlider,
  ChatTextarea,
}